import {PincodeService} from './pincode-service';
import {Environment} from '../../shared/environment/environment';
import {LocalApiService} from '../local-api/local-api.service';

export class PincodeServiceFactory {

  // This factory exists to keep the 'function call' Environment.environmentConfig out of the app.module
  // Directly calling the environmentConfig in app.module will result in an error saying Function calls are not supported in Decorators
  static createPincodeService(localApiService: LocalApiService): PincodeService {
    const serviceType = Environment.environmentConfig().pincodeServiceType;
    return new serviceType(localApiService);
  }
}
